import { render } from "./chat_list.vue?vue&type=template&id=20b0f4c4"
import script from "./chat_list.js?vue&type=script&lang=js&external"
export * from "./chat_list.js?vue&type=script&lang=js&external"

import "./chat_list.vue?vue&type=style&index=0&id=20b0f4c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__